import React, { Fragment } from "react"
import { Text, View, StyleSheet } from "@react-pdf/renderer"
import formatNumberWithCommas from "../../../../../utils/formatNumberWithCommas"
import markUpCalc from "../../../../../utils/markUpCalc"

// Create styles
const styles = StyleSheet.create({
  labels: {
    backgroundColor: "#FFFFFF",
    lineHeight: 1,
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-end",
  },
  roleHeader: {
    borderRadius: "4px",
    padding: "5px 10px",
    backgroundColor: "#FAF7F7",
  },
  itemWrapper: {
    backgroundColor: "#FFF0EF",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    borderRadius: "4px",
    padding: "5px 10px",
    margin: "2px 0 0 2px",
  },
  expenseRow: {
    display: "flex",
    flexDirection: "row",
    flexGrow: 1,
  },
  expenseName: {
    width: "60%",
  },
  expenseNumberItem: {
    width: "20%",
    textAlign: "right",
  },
})

const PdfTable = ({ expenses = [], type = "", additional = false }) => {
  return (
    <Fragment>
      {/* map over expenses... */}
      <View style={{ marginBottom: "10px" }}>
        <View style={styles.labels}>
          <Text style={[styles.expenseName, { marginLeft: "10px" }]}>
            {additional ? "ADDITIONAL ITEM" : "ITEM"}
          </Text>
          <Text style={[styles.expenseNumberItem, { marginRight: "20px" }]}>
            QTY
          </Text>
          <Text style={[styles.expenseNumberItem, { marginRight: "30px" }]}>
            RATE
          </Text>
          <Text style={[styles.expenseNumberItem, { marginRight: "20px" }]}>
            TOTAL
          </Text>
        </View>
        {expenses.map((exp, i) => {
          return (
            <View key={i} style={styles.itemWrapper}>
              <View style={styles.expenseRow}>
                <Text style={styles.expenseName}>{exp.type_name}</Text>
                <Text>{exp.quantity}</Text>

                {/* show actual RATE both ways - act as if this is a crew-facing pdf */}
                <Text style={styles.expenseNumberItem}>
                  $ {formatNumberWithCommas(Number(exp.actual_rate))}
                </Text>
                {/* show actual * quantity both ways - act as if this is a crew-facing pdf */}
                <Text style={styles.expenseNumberItem}>
                  ${" "}
                  {formatNumberWithCommas(
                    Number(exp.actual_rate) * Number(exp.quantity)
                  )}
                </Text>
              </View>
              <View style={[styles.expenseRow, { marginTop: "5px" }]}>
                <Text style={styles.expenseName}>{exp.description}</Text>
              </View>
            </View>
          )
        })}
        {/* Display no expenses message if role has none */}
        {expenses.length === 0 && (
          <View style={styles.expenseRow}>
            <Text style={{ width: "100%" }}>
              No {additional ? "additional expenses" : "expenses"} tied to this
              role.
            </Text>
          </View>
        )}
      </View>
    </Fragment>
  )
}

export default PdfTable
